import React, { useMemo } from "react";
import { config as baseConfig } from "../config";
import { resolveTokenColor, formatDataValue } from "./chartUtils";

const InfoData = ({ labels = [], values = [], colorMap, colors }) => {
  const resolvedColors = useMemo(
    () =>
      (colors || baseConfig.colors).map((c, i) => {
        const resolved =
          (colorMap && colorMap[i]) || resolveTokenColor(c) || "#3b82f6";
        return resolved;
      }),
    [colors, colorMap]
  );
  return (
    <div
      className="w-fit h-fit flex items-center max-w-[600px] max"
      style={{
        background: "#fff",
        border: "1px solid #d1d5db",
        borderRadius: 8,
        boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
      }}
    >
      <div className="w-full flex flex-col gap-2 p-2">
        {labels.map((label, i) => {
          const color =
            (colorMap && colorMap[i]) ||
            resolvedColors[i % resolvedColors.length] ||
            "#3b82f6";
          const val = values[i] || 0;
          return (
            <div
              key={`info-${i}`}
              style={{
                display: "grid",
                gridTemplateColumns: "16px 1fr auto",
                alignItems: "center",
                gap: 8,
              }}
            >
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "9999px",
                  background: color,
                  display: "inline-block",
                }}
              />
              <span
                style={{
                  fontSize: "12px",
                  color: resolveTokenColor(baseConfig.axis.labelColor),
                }}
              >
                {label || `Slice ${i + 1}`}
              </span>
              <span
                style={{
                  fontSize: "12px",
                  color: resolveTokenColor(baseConfig.axis.labelColor),
                }}
              >
                {formatDataValue(val)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default InfoData;
